import { render, staticRenderFns } from "./BulkEdit.vue?vue&type=template&id=4833b4ea&scoped=true&"
import script from "./BulkEdit.vue?vue&type=script&lang=js&"
export * from "./BulkEdit.vue?vue&type=script&lang=js&"
import style0 from "./BulkEdit.vue?vue&type=style&index=0&id=4833b4ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4833b4ea",
  null
  
)

export default component.exports